<template>
  <!--右侧菜单-->
  <div>
    <!--我的收藏-->
    <!--标题-->
    <p class="fav_mainHead">我的收藏</p>
    <!--内容-->
    <div class="member_class_list">
      <h5 class="none_ts" v-if="userCollects.length == 0" style="text-align: center;">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
      <dl v-if="userCollects.length > 0" v-for="item in userCollects" :key="item.id">
        <dt>
          <a href="javascript:;" @click="course_detail(item.course.id)">
            <img v-if="item.course.faceUrl" :src="item.course.faceUrl"/>
            <img v-if="!item.course.faceUrl || item.course.faceUrl==''" src="@/assets/images/class_img.jpg"/>
          </a>
        </dt>
        <dd>
          <h3>{{item.course.name}}</h3>
          <p v-if="item.course.teacherName && item.course.teacherName.length>0">
            讲师:<span v-if="item.course.teacherName.length==1">{{item.course.teacherName[0]}}</span>
            <span v-if="item.course.teacherName.length>1">{{item.course.teacherName[0]}}等</span>
            <a href="javascript:;" @click="cancelFav(item.id)">取消收藏</a>
          </p>
          <p v-if="!item.course.teacherName">
            <a href="javascript:;" @click="cancelFav(item.id)">取消收藏</a>
          </p>
        </dd>
      </dl>
    </div>
    <div class="zy_list_bottom" v-if="favCnt>0">
      <dl>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/我的收藏-->
  </div>
  <!--/右侧菜单-->
</template>
<script>
  import { getCookie } from '@/store/cookies'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: this.$global.paginationOptions.uc_page_num,
        delFlag: '0'
      },
      userCollects: [],
      favCnt: 0,
      pages: 0
    }
  },
  created () {
    this.getUserCollects(this.filter)
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getUserCollects(this.filter)
    },
    getUserCollects (filter) {
      this.$api.post(this.$global.courseApiPath, '/course/collect/collects', filter, r => {
        if (r.data && r.data.length>0) {
          this.favCnt = r.cntData
          this.pages = Math.ceil(this.favCnt / this.filter.pageSize)
          this.userCollects = r.data
        } else {
          this.favCnt = 0
          this.pages = 0
          this.userCollects = []
        }
      })
    },
    cancelFav (courseId) {
      this.$api.getRestful(this.$global.courseApiPath, '/course/collect/delete/' + courseId, {}, r => {
        this.$toasted.show('取消收藏成功！', {
          duration: 800
        })
        this.getUserCollects(this.filter)
      })
    },
    course_detail (id) {
      var path = this.$OR.getUrl(getCookie('org').businessId)
      this.$router.push({
        path: path + '/courseDetail/' + id
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/fav.vue